import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { getCacheUserPortalSettings } from '@/service/EndUserPortalService';

export const useThemeStore = defineStore(
    'theme',
    () => {
        /**
         * States
         */
        const themeSettings = ref(null);

        /**
         * Getters
         */
        const themeColors = computed(() => {
            if (!themeSettings.value) {
                return {
                    main: null,
                    hover: null,
                    active: null,
                }
            }

            return {
                main: themeSettings.value.main_color,
                hover: themeSettings.value.hover_color,
                active: themeSettings.value.active_color,
            };
        });

        /**
         * Actions
         */
        // TODO:
        //  Whenever there are changes on the theme, the user should be notified that for it to take effect, they
        //  should log out and login again. And ensure that during logout, the theme settings are also cleared.
        async function getThemeSettings() {
            try {
                themeSettings.value = await getCacheUserPortalSettings();
            } catch (error) {
                console.error('Error fetching theme settings:', error);
            }
        }

        return {
            /** States */
            themeSettings,

            /** Getters */
            themeColors,

            /** Actions */
            getThemeSettings,
        };
    });